// frontend/src/components/Signup.js
import React, { useState } from 'react';
import axios from '../api';
import Loader from './Loader';

function Signup() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  
  const validateForm = () => {
    const newErrors = {};
    
    // Username validation
    if (!username.trim()) {
      newErrors.username = 'Username is required';
    } else if (username.length < 3) {
      newErrors.username = 'Username must be at least 3 characters';
    } else if (!/^[a-zA-Z0-9_]+$/.test(username)) {
      newErrors.username = 'Username can only contain letters, numbers, and underscores';
    }
    
    // Password validation
    if (!password) {
      newErrors.password = 'Password is required';
    } else if (password.length < 6) {
      newErrors.password = 'Password must be at least 6 characters';
    }
    
    // Confirm password validation
    if (password !== confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setLoading(true);
    
    try {
      await axios.post('/signup', { username, password });
      
      setTimeout(() => {
        alert('Signup successful! Redirecting to login...');
        window.location = '/login';
      }, 1500);
    } catch (err) {
      setLoading(false);
      const errorMsg = err.response?.data?.error || err.message;
      setErrors({ submit: errorMsg });
    }
  };

  if (loading) return <Loader />;

  return (
    <div className="parallax-bg">
      <FloatingTexts />
      <div className="neon-form-container">
        <form onSubmit={handleSubmit} className="neon-form">
          <h2>Create Account</h2>
          <p className="subtitle">Join FinTract and manage your finances</p>
          
          <div style={{ marginBottom: '1.25rem' }}>
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => {
                setUsername(e.target.value);
                if (errors.username) setErrors({ ...errors, username: '' });
              }}
              style={{
                borderColor: errors.username ? '#ff4444' : 'rgba(255, 255, 255, 0.1)'
              }}
            />
            {errors.username && (
              <p style={{ 
                color: '#ff4444', 
                fontSize: '0.85rem', 
                marginTop: '0.5rem',
                marginLeft: '0.25rem'
              }}>
                {errors.username}
              </p>
            )}
          </div>
          
          <div style={{ marginBottom: '1.25rem' }}>
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                if (errors.password) setErrors({ ...errors, password: '' });
              }}
              style={{
                borderColor: errors.password ? '#ff4444' : 'rgba(255, 255, 255, 0.1)'
              }}
            />
            {errors.password && (
              <p style={{ 
                color: '#ff4444', 
                fontSize: '0.85rem', 
                marginTop: '0.5rem',
                marginLeft: '0.25rem'
              }}>
                {errors.password}
              </p>
            )}
          </div>
          
          <div style={{ marginBottom: '1.25rem' }}>
            <input
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => {
                setConfirmPassword(e.target.value);
                if (errors.confirmPassword) setErrors({ ...errors, confirmPassword: '' });
              }}
              style={{
                borderColor: errors.confirmPassword ? '#ff4444' : 'rgba(255, 255, 255, 0.1)'
              }}
            />
            {errors.confirmPassword && (
              <p style={{ 
                color: '#ff4444', 
                fontSize: '0.85rem', 
                marginTop: '0.5rem',
                marginLeft: '0.25rem'
              }}>
                {errors.confirmPassword}
              </p>
            )}
          </div>
          
          {errors.submit && (
            <p style={{ 
              color: '#ff4444', 
              fontSize: '0.9rem', 
              marginBottom: '1rem',
              textAlign: 'center',
              padding: '0.75rem',
              background: 'rgba(255, 68, 68, 0.1)',
              borderRadius: '8px',
              border: '1px solid rgba(255, 68, 68, 0.3)'
            }}>
              {errors.submit}
            </p>
          )}
          
          <button type="submit" className="neon-button">
            <span className="text">Sign Up</span>
          </button>
          
          <div className="auth-switch">
            Already have an account? <a href="/login">Log In</a>
          </div>
        </form>
      </div>
    </div>
  );
}

// Floating finance-related texts component
function FloatingTexts() {
  const texts = [
    'TRANSACTIONS', 'EXPENSES', 'CREDIT SCORE', 'BALANCE', 
    'STATEMENTS', 'ANALYTICS', 'PAYMENTS', 'SAVINGS',
    'BUDGET', 'INVOICE', 'CASHFLOW', 'INTEREST',
    'MERCHANT', 'DEBIT', 'REVENUE', 'PORTFOLIO'
  ];
  
  return (
    <div className="floating-texts">
      {texts.map((text, index) => (
        <div
          key={index}
          className="float-text"
          style={{
            left: `${Math.random() * 90}%`,
            animationDelay: `${Math.random() * 20}s`,
            animationDuration: `${15 + Math.random() * 10}s`
          }}
        >
          {text}
        </div>
      ))}
    </div>
  );
}

export default Signup;